import { useCallback, useEffect, useState } from 'react';
import { HardDrive, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { ownerApi, apiError } from './ownerApi';
import { CostBlock, GcsBlock, LegacyBlock, MongoBlock, fmtTime } from './StorageBlocks';

export const StorageCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback((refresh = false) => {
    setBusy(true);
    return ownerApi.get('/platform-owner/storage-usage', { params: refresh ? { refresh: true } : {} })
      .then((r) => { setD(r.data); if (r.data.cooldown) toast.info('Bilgiler az önce güncellendi; 1 dakika sonra tekrar yenileyebilirsiniz.'); })
      .catch((e) => toast.error(apiError(e))).finally(() => setBusy(false));
  }, []);
  useEffect(() => { load(); }, [load]);
  const savePrice = (v) => {
    if (!(v > 0 && v <= 1)) return toast.error('Fiyat 0 ile 1 USD arasında olmalı');
    setBusy(true);
    return ownerApi.put('/platform-owner/storage-usage/price', { usd_per_gb_month: v })
      .then((r) => { setD(r.data); toast.success('Fiyat kaydedildi'); }).catch((e) => toast.error(apiError(e))).finally(() => setBusy(false));
  };

  return (
    <section className="space-y-4 rounded-2xl border border-slate-200 bg-white p-6" data-testid="owner-storage-card">
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-50 text-orange-500"><HardDrive className="h-5 w-5" /></span>
        <h2 className="text-lg font-semibold text-slate-900">Depolama</h2>
        <Button variant="ghost" size="sm" className="ml-auto h-8 px-2" disabled={busy} onClick={() => load(true)} data-testid="owner-storage-refresh" title="Yenile">
          <RefreshCw className={`h-4 w-4 ${busy ? 'animate-spin' : ''}`} />
        </Button>
      </div>
      {!d ? <p className="text-sm text-slate-500" data-testid="owner-storage-loading">Yükleniyor...</p> : (
        <>
          <GcsBlock g={d.gcs} />
          <MongoBlock m={d.mongo} />
          <LegacyBlock l={d.legacy} />
          <CostBlock key={d.cost.usd_per_gb_month} c={d.cost} onSave={savePrice} saving={busy} />
          <p className="text-xs text-slate-400" data-testid="owner-storage-updated">Son güncelleme: {fmtTime(d.updated_at)}{d.cached ? ' · önbellekten' : ''}</p>
        </>
      )}
    </section>
  );
};
